import React, { Component } from 'react'
import { connect } from 'react-redux'

import triggerCustomGaEvent from '../../utilities/analytics/triggerCustomGaEvent'

import BkFlowLanguageToggleDefault from './layouts/BkFlowLanguageToggleDefault'
import BkFlowLanguageToggleIconMenu from './layouts/BkFlowLanguageToggleIconMenu'

class BkFlowLanguageToggle extends Component {
	constructor(props) {
		super(props)

		const queryString = require('query-string')
		const urlQuery = queryString.parse(window.location.search)

		let currentLanguage = 'en'

		if (
			urlQuery &&
			urlQuery.primaryLangId
		) {
			currentLanguage = urlQuery.primaryLangId
		}

		this.state = {
			currentLanguage: currentLanguage,
			languageMenuVisible: false
		}
	}

	handleToggleLanguageMenu = () => {
		this.setState({
			languageMenuVisible: !this.state.languageMenuVisible
		})
	}

	// Manually update language
	handleSelectLanguage = (currency) => {
		const stayParameters = new URLSearchParams(window.location.search)

		this.setState({
			currentLanguage: currency
		})

		if (stayParameters.has('primaryLangId')) {
			stayParameters.set('primaryLangId',currency)
		}

		triggerCustomGaEvent('analytics-updateLanguage', currency)

		// Redirect with updated parameters
		window.location.href = '/book?' + stayParameters.toString()
	}

	render() {
		const { configData } = this.props

		const hotelComponents = configData.hotel.options.components,
					hotelLabels = configData.hotel.labels[0],
					supportedLanguages = hotelComponents.supportedLanguages

		let languageOptions = []

		// Construct currency select options
		if ( supportedLanguages ) {
			for (let languageKey in supportedLanguages) {
				if (process.env.REACT_APP_COMPONENT_LANGUAGE_TOGGLE_LAYOUT === 'icon-menu') {
					languageOptions.push(
						<button
							key={supportedLanguages[languageKey].value}
							className="btn btn-primary"
							onClick={() => this.handleSelectLanguage(supportedLanguages[languageKey].value)}
						>
							{supportedLanguages[languageKey].label}
						</button>
					)
				} else {
					languageOptions.push(
						<option
							key={supportedLanguages[languageKey].value}
							value={supportedLanguages[languageKey].value}
						>
							{supportedLanguages[languageKey].label}
						</option>
					)
				}
			}
		}

		return (
			process.env.REACT_APP_COMPONENT_LANGUAGE_TOGGLE_LAYOUT === 'icon-menu' ? (
				<BkFlowLanguageToggleIconMenu
					currentLanguage={this.state.currentLanguage}
					languageMenuEvent={() => this.handleToggleLanguageMenu()}
					languageOptions={languageOptions}
					languageMenuVisible={this.state.languageMenuVisible}
				/>
			) : (
				<BkFlowLanguageToggleDefault
					hotelLabels={hotelLabels}
					currentLanguage={this.state.currentLanguage}
					languageEvent={(currency) => this.handleSelectLanguage(currency)}
					languageOptions={languageOptions}
				/>
			)
		)
	}
}

function mapStateToProps(state) {
	return {
		configData: state.configData.configuration,
		urlData: state.availabilityData.urlData
	}
}

export default connect(mapStateToProps, null)(BkFlowLanguageToggle)


// WEBPACK FOOTER //
// ./src/components/language/BkFlowLanguageToggle.js